import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import FurnData from "../../data/Data";

const FurnitureDetails = () => {

  const { id } = useParams();
  const selectedFurniture = FurnData.find(
    (item) => item.id.toString() === id
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  if (!selectedFurniture) {
    return <div className="p-8 text-center text-xl">Furniture not found.</div>;
  }

  return (
    <div className="font-basefont cursor-default">
      <div className="min-h-screen bg-white lg:mt-20 mt-10 flex flex-col justify-center items-center p-6">
        <div className="grid md:grid-cols-2 gap-6 w-full max-w-6xl">

          <div className="relative group">
            <img
              src={selectedFurniture.image || "https://via.placeholder.com/600x400?text=No+Image"}
              alt={`Furniture ${selectedFurniture.id}`}
              className="h-full w-full object-cover rounded-lg"
            />
          </div>

          <div className="rounded-2xl flex flex-col justify-center items-center lg:p-4">
            <table className="w-full border border-black lg:mb-6 rounded-md">
              <tbody>
                <tr className="border border-black">
                  <td colSpan="2" className="p-2 text-left font-semibold uppercase">
                    {selectedFurniture.name}
                  </td>
                </tr>
                <tr className="border border-black">
                  <td className="italic border border-black p-2">Primary Material</td>
                  <td className="border border-black p-2">{selectedFurniture.primary_material}</td>
                </tr>

                {selectedFurniture.seat_height && (
                  <tr className="border border-black">
                    <td className="italic border border-black p-2">Seat Height</td>
                    <td className="border border-black p-2">{selectedFurniture.seat_height}</td>
                  </tr>
                )}

                {selectedFurniture.arm_height && (
                  <tr className="border border-black">
                    <td className="italic border border-black p-2">Arm Height</td>
                    <td className="border border-black p-2">{selectedFurniture.arm_height}</td>
                  </tr>
                )}

                <tr className="border border-black">
                  <td className="italic border border-black p-2">Dimensions</td>
                  <td className="border border-black p-2">
                    {typeof selectedFurniture.dimensions === "string"
                      ? selectedFurniture.dimensions
                      : Object.entries(selectedFurniture.dimensions).map(([key, value]) => (
                        <div key={key}>{key}: {value}</div>
                      ))}
                  </td>
                </tr>

                <tr className="border border-black">
                  <td className="italic border border-black p-3">Delivery Time</td>
                  <td className="border border-black p-2">{selectedFurniture.delivery_time}</td>
                </tr>

                <tr className="border border-black">
                  <td className="italic border border-black p-3">Description</td>
                  <td className="border border-black p-2">{selectedFurniture.description}</td>
                </tr>

                {selectedFurniture.shipping_charges_and_gst && (
                  <tr className="border border-black">
                    <td className="italic border border-black p-3">Shipping & GST</td>
                    <td className="border border-black p-2">{selectedFurniture.shipping_charges_and_gst}</td>
                  </tr>
                )}

                <tr>
                  <td colSpan="2" className=" text-center ">
                    <a
                      target="_blank"
                      href="https://wa.me/919444161667"
                      rel="noreferrer"
                      className="block w-full text-center bg-[#ebd2a7] text-black px-8  py-2 
                      text-lg hover:bg-gray-800 hover:text-white transition">
                      Enquire →
                    </a>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>





  );
};

export default FurnitureDetails;
